import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { GetBankAccountListPagingAndFilterRequest } from '../models/request/bankAccount/GetBankAccountListPagingAndFilterRequest';

export class BankAccountService {
    static async getBankAccountList() {
        try {
            var inputObj = {

            };

            console.log('SERVICE CALL - getBankAccountList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/BankAccount/getBankAccountList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportBankAccountList(inputObj: GetBankAccountListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportBankAccountList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/BankAccount/exportBankAccountList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getBankAccountListPagingAndFilter(inputObj: GetBankAccountListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetBankAccountListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/BankAccount/GetBankAccountListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async addBankAccount(_bankAccountId: string | undefined, _name: string | undefined, _bankId: string | undefined, _openingBalance: string | undefined, _iban: string | undefined, _accountNo: string | undefined, _currencyTypeId: string | undefined, _accountingCode: string | undefined, _branchCode: string | undefined, _openingBalanceDate: string | undefined, _isCustomActive: number) {
        try {
            var inputObj = {
                bankAccountId: _bankAccountId,
                name: _name,
                bankId: _bankId,
                openingBalance: _openingBalance,
                iban: _iban,
                accountNo: _accountNo,
                currencyTypeId: _currencyTypeId,
                accountingCode: _accountingCode,
                branchCode: _branchCode,
                openingBalanceDate: _openingBalanceDate,
                isCustomActive: _isCustomActive
            };

            console.log('SERVICE CALL - AddBankAccount', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/BankAccount/AddBankAccount', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deleteBankAccount(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deleteBankAccount', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/BankAccount/deleteBankAccount', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getBankAccountById(_id: string) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getBankAccountById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/BankAccount/getBankAccountById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}